import mixpanel from 'mixpanel-browser';
export default {
	install: (vue, { config = {}, token }) => {
		const defaultConfig = {};
		const endConfig = Object.assign(config, defaultConfig);
		mixpanel.init(token, endConfig);
		vue.prototype.$mixpanel = mixpanel;
	}
};